import { UpdateResolver } from '@urql/exchange-graphcache';
import {
  CreateSharedLinkWithDurationMutation,
  CreateSharedLinkWithDurationMutationVariables,
  GetSharedLinksDocument,
  GetSharedLinksQuery,
  SharedLink,
  DeleteSharedLinkMutation,
  DeleteSharedLinkMutationVariables,
} from '../../gql/graphql';

export const createSharedLinkResolver: UpdateResolver<
  CreateSharedLinkWithDurationMutation,
  CreateSharedLinkWithDurationMutationVariables
> = (result, args, cache) => {
  const newSharedLink = result.createSharedLinkWithDuration?.sharedLink;

  if (newSharedLink) {
    const projectId = (args as any).input?.theProjectId;

    if (!projectId) {
      console.error(
        '[createSharedLinkResolver] projectId not found in args.input.theProjectId:',
        args
      );
      return;
    }

    const queryToUpdate = {
      query: GetSharedLinksDocument,
      variables: { projectId },
    };

    cache.updateQuery<GetSharedLinksQuery, { projectId: string }>(
      queryToUpdate,
      (cachedData) => {
        if (cachedData && cachedData.sharedLinks) {
          const linkToAdd = newSharedLink as SharedLink;
          if (
            !cachedData.sharedLinks.some((link) => link.id === linkToAdd.id)
          ) {
            return {
              ...cachedData,
              sharedLinks: [...cachedData.sharedLinks, linkToAdd],
            };
          }
        } else {
          return {
            sharedLinks: [newSharedLink as SharedLink],
          } as GetSharedLinksQuery;
        }
        return cachedData;
      }
    );
  }
};

export const deleteSharedLinkResolver: UpdateResolver<
  DeleteSharedLinkMutation,
  DeleteSharedLinkMutationVariables
> = (result, args, cache) => {
  const deletedSharedLink = result.deleteSharedLink?.sharedLink;

  if (deletedSharedLink?.id && deletedSharedLink.projectId) {
    const queryToUpdate = {
      query: GetSharedLinksDocument,
      variables: { projectId: deletedSharedLink.projectId },
    };

    cache.updateQuery<GetSharedLinksQuery, { projectId: string }>(
      queryToUpdate,
      (cachedData) => {
        if (cachedData?.sharedLinks) {
          return {
            ...cachedData,
            sharedLinks: cachedData.sharedLinks.filter(
              (link) => link.id !== deletedSharedLink.id
            ),
          };
        }
        return cachedData;
      }
    );
  } else {
    console.error(
      '[deleteSharedLinkResolver] Could not find id or projectId on deletedSharedLink:',
      deletedSharedLink,
      'Result:',
      result
    );
  }
};
